export default {
  "content": "<g clip-path=\"url(#icon_question_rounded_outlined_svg__a)\"><path d=\"M8 1c3.86 0 7 3.14 7 7s-3.14 7-7 7-7-3.14-7-7 3.14-7 7-7zm0-1C3.58 0 0 3.58 0 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8z\"/><path d=\"M8 5c1.26 0 1.89.8 1.89 1.62 0 .78-.54 1.2-.99 1.62-.24.23-.41.35-.42 1.01h-.94c0-.57.1-.84.35-1.22.33-.51.94-.74.94-1.32 0-.42-.3-.72-.81-.72-.65 0-.94.5-.86 1.11H6.15c-.13-1.27.77-2.09 1.87-2.09L8 5zm-.61 4.78H8.6v1.21H7.39V9.78z\"/></g><defs><clipPath id=\"icon_question_rounded_outlined_svg__a\"><path d=\"M0 0h16v16H0z\"/></clipPath></defs>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "16",
    "height": "16",
    "fill": "currentColor",
    "viewBox": "0 0 16 16"
  }
};